<template>
  <button
    :class="{
      'btn-default': buttonStyle === 'default',
      'btn-primary': buttonStyle === 'primary',
      'btn-nis-primary': buttonStyle === 'nis-primary',
      'btn-success': buttonStyle === 'success',
      'btn-sm': size === 'small',
      'btn-lg': size === 'large',
      'btn-lowercase': lowercase
    }"
    :disabled="disabled"
    :type="type"
    class="btn"
    @click="handleClick">
    <slot name="icon"></slot>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'af-button',
  props: {
    disabled: Boolean,
    lowercase: Boolean,
    size: String,
    buttonStyle: {
      default: 'default',
      type: String
    },
    type: {
      default: 'button',
      type: String
    }
  },
  methods: {
    handleClick() {
      this.$emit('clicked')
    }
  }
}
</script>

<style scoped src="./Button.css"></style>



// WEBPACK FOOTER //
// src/components/Button/Button.vue